import api from '@/services/api';
import { PaginatedResponse } from '@/types/common';
import { Area } from '@/types/areas';

export const areasService = {
  async getAll(): Promise<PaginatedResponse<Area>> {
    const response = await api.get<PaginatedResponse<Area>>('/areas?offset=0&limit=1000');
    return response.data;
  },
};
